import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { toaster } from '@gravity-ui/uikit/toaster-singleton';
import i18n from '@yandex-int/i18n';
import { routes } from 'client/lib/routes';
import { getIsYangoRequest } from 'client/utils';
import { hasSkip2faCheck } from 'common/featureFlags';
import * as keyset from 'i18n/TwoFaBanner';

import { dismiss, isDismissed } from './twoFaDismiss';

const t = i18n(keyset);

const TOAST_NAME = 'two-fa-toast';
const ENABLE_2FA_URL = 'https://id.yandex.ru/security';
const ENABLE_2FA_URL_YANGO = 'https://id.yango.com/security';

const isQuickAppsPath = (pathname: string): boolean => pathname.startsWith(routes.app.quickApps());

export const useTwoFaToast = (): void => {
    const { pathname } = useLocation();

    useEffect(() => {
        const user = __appConfig?.user;

        if (
            !user ||
            user.is2faEnabled ||
            hasSkip2faCheck(user.featureFlags) ||
            isDismissed() ||
            !__appConfig?.app?.display2faBanner ||
            isQuickAppsPath(pathname)
        ) {
            return;
        }

        toaster.add({
            name: TOAST_NAME,
            title: t('two-fa-banner-title'),
            content: t('two-fa-banner-text'),
            theme: 'warning',
            autoHiding: false,
            isClosable: true,
            actions: [
                {
                    label: t('two-fa-banner-link'),
                    onClick: () => {
                        dismiss();
                        window.open(getIsYangoRequest() ? ENABLE_2FA_URL_YANGO : ENABLE_2FA_URL, '_blank');
                    },
                },
            ],
            onClose: dismiss,
        });

        return () => {
            if (toaster.has(TOAST_NAME)) {
                toaster.remove(TOAST_NAME);
            }
        };
    }, [pathname]);
};
